<template>
	<div class="height-100dvh">
		<div id="hideinlaptop" class="mob-back-header d-flex align-items-center">
			<img
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
				@click="goToHome()"
			/>
			Become a Panelist
		</div>
		<main class="resda-main-container w-100">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<img
					@click="goToHome()"
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
				/>
				Become a panelist
			</div>
			<div v-if="results == 'selected'" class="resda-down-cont max-1825">
				<section class="resda-left-cont">
					<h2 class="fam-mont text-blue fw-M resda-fs-32 mb-0">
						Your Panelist Application Results 🎉
					</h2>
					<h5 class="fam-lato text-darkgrey fw-R resda-fs-20 z-ind-2">
						Congratulations {{ userInfo.displayName }}! Based on our evaluation,
						you have been qualified to conduct interviews in the following
						domains:
					</h5>
					<div class="resda-qual-skill">
						<div class="d-flex align-items-center text-blue fw-M">
							<img
								class="mr-2"
								src="../../assets/newdesign/BecomePanelist/qualified-tick.svg"
								alt=""
							/>
							Your qualified skill(s) with experience level interviewable :
						</div>
						<div class="resda-greentxt">{{ qualifiedText }} Qualified</div>
					</div>
					<div class="resda-scroll">
						<div class="wrapper-scroll">
							<article
								v-for="(panel, index) in panelData"
								:key="index"
								:class="panel.qualified == false ? 'resda-red-border' : ''"
							>
								<!-- <img
								v-if="i == 1"
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/java.svg"
								alt=""
							/>
							<img
								v-else-if="i == 2"
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/redux.svg"
								alt=""
							/>
							<img
								v-else-if="i == 3"
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/github.svg"
								alt=""
							/>
							<img
								v-else-if="i == 4"
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/gitlab.svg"
								alt=""
							/>
							<img
								v-else-if="i == 5"
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/c++.svg"
								alt=""
							/>
							<img
								v-else-if="i == 6"
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/preact.svg"
								alt=""
							/>
							<img
								v-else-if="i == 7"
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/flutter.svg"
								alt=""
							/>
							<img
								v-else
								class="resda-card-dp"
								src="../../assets/newdesign/BecomePanelist/django.svg"
								alt=""
							/> -->
								<img class="resda-card-dp" :src="panel.image" alt="" />
								<div class="text-truncate max-wid-85">
									{{ panel.skillName }}
								</div>
								<img
									v-if="panel.qualified == false"
									class="resda-card-svg"
									src="../../assets/newdesign/BecomePanelist/card-red-cros.svg"
									alt=""
								/>
								<img
									v-if="panel.qualified == true"
									class="resda-card-svg"
									src="../../assets/newdesign/BecomePanelist/card-green-tick.svg"
									alt=""
								/>
								<div
									class="resda-card-exp"
									v-if="panel.experienceFrom && panel.experienceTo"
								>
									({{ panel.experienceFrom }} - {{ panel.experienceTo }}) Years
								</div>
							</article>
						</div>
						<!-- <div class="resda-qual-experience">
						<div class="d-flex align-items-center text-darkgrey fw-M">
							Candidate Experience Level Interviewable :
						</div>
						<div class="resda-blue-txt">{{ qualifiedExperience }} Years</div>
					</div> -->
					</div>
					<b-button
						id="hideinmobile"
						class="candash-addBtn mt-3 w-50"
						@click="goToDashboard()"
						>Go to dashboard</b-button
					>
					<section id="hideinlaptop" class="resda-back-img-size">
						<img
							class="h-100 w-100"
							src="../../assets/newdesign/BecomePanelist/resda-back.svg"
							alt=""
						/>
					</section>
				</section>
				<section id="hideinmobile" class="resda-back-img-size">
					<img
						class="h-100 w-100"
						src="../../assets/newdesign/BecomePanelist/resda-back.svg"
						alt=""
					/>
				</section>
			</div>
			<div v-else-if="results == 'rejected'" class="resda-down-cont max-1825">
				<div class="resda-left-cont">
					<div class="resda-scroll-2">
						<div class="resda-red-txt d-flex align-items-center gap-2">
							<img
								src="../../assets/newdesign/BecomePanelist/application-rej.svg"
								alt=""
							/>Application rejected!
						</div>
						<div class="resda-black-txt text-darkgrey fam-lato">
							Thanks a lot for applying with us, But unfortunately you aren’t
							quite matching the selection criteria and requirements at the
							moment. Not to worry you can re-apply for the panelist position
							once the cooling down period is over.
						</div>
						<div>
							<div class="resda-top">VISIT US BACK ON</div>
							<div class="resda-bottom">{{ formattedDate }}</div>
						</div>
					</div>
					<b-button
						id="hideinmobile"
						@click="goToDashboard()"
						class="candash-addBtn mt-3 w-50"
						>{{ btntxt }}</b-button
					>
				</div>
				<section class="resda-back-img-size-2">
					<img
						class="w-100"
						src="../../assets/newdesign/BecomePanelist/application-rej-back.svg"
						alt=""
					/>
				</section>
			</div>
			<div v-else class="resda-down-cont max-1825">
				<Spinner :id="'streak'" class="w-100"></Spinner>
			</div>
			<footer id="hideinlaptop">
				<b-button
					v-if="results == 'selected'"
					@click="goToDashboard()"
					class="candash-addBtn w-100"
					>Proceed</b-button
				>
				<b-button
					v-else
					@click="goToDashboard()"
					class="candash-addBtn w-100"
					>{{ btntxt }}</b-button
				>
			</footer>
		</main>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import mobHeader from "@/components/fixedcomponents/mobileHeader.vue";
import { postPanelResult, userInfo } from "@/utils/apiFunctions";
import Spinner from "@/components/fixedcomponents/Spinner.vue";

export default {
	data() {
		return {
			btntxt: "",
			opendropdown: false,
			loopvar: 15,
			panelData: [],
			results: "",
			rejoinDate: "",
			qualifiedText: "",
			qualifiedExperience: "",
		};
	},
	created() {
		this.getuserInfo();
		this.fetchPanelResults();
	},
	components: {
		mobHeader,
		Spinner,
	},
	computed: {
		formattedDate() {
			const date = new Date(this.rejoinDate);
			return date
				.toLocaleDateString("en-GB", {
					day: "2-digit",
					month: "long",
					year: "numeric",
				})
				.toUpperCase();
		},
		...mapGetters("userVUEX", ["getUserInfo"]),
		userInfo() {
			return this.getUserInfo || {};
		},
	},
	methods: {
		async fetchPanelResults() {
			try {
				let payload = {
					userID: this.userInfo.userID,
				};
				const response = await postPanelResult(payload);
				if (response.status === 200) {
					this.panelData = response.data.data.skills;
					this.results = response.data.data.result;
					this.rejoinDate = response.data.data.rejoinDate;
					this.qualifiedText = response.data.data.qualifiedText;
					this.qualifiedExperience = response.data.data.qualifiedExperience;
					this.customButtonText();
				}
			} catch (error) {
				console.error("Error fetching:", error);
			}
		},
		goToDashboard() {
			if (this.results === "selected") {
				this.$router.push({ name: "PanelDashboard" });
			} else {
				const rejoinDateNew = new Date(this.rejoinDate);
				const currentDate = new Date();
				// Normalize both dates to only compare year, month, and day
				rejoinDateNew.setHours(0, 0, 0, 0);
				currentDate.setHours(0, 0, 0, 0);
				if (rejoinDateNew <= currentDate) {
					this.$router.push({ name: "ChooseExpertise" });
				} else {
					this.$router.push({ name: "Homepage" });
				}
			}
		},
		customButtonText() {
			const rejoinDateNew = new Date(this.rejoinDate);
			const currentDate = new Date();
			// Normalize both dates to only compare year, month, and day
			rejoinDateNew.setHours(0, 0, 0, 0);
			currentDate.setHours(0, 0, 0, 0);
			if (rejoinDateNew <= currentDate) {
				this.btntxt = "Apply";
			} else {
				this.btntxt = "Go Back";
			}
		},
		goToHome() {
			this.$router.push({
				name: "Homepage",
			});
		},
		async getuserInfo() {
			const res = await userInfo();
			if (res.status == 200) {
				console.log("profile");
				this.$store.commit("userVUEX/setUserInfo", res.data.data);
			}
		},
	},
};
</script>

<style>
.resda-main-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.resda-down-cont {
	height: calc(100vh - 100px);
	overflow: auto;
	border-radius: 8px;
	background-color: #f0f5ff;
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	display: flex;
	justify-content: space-between;
}

.resda-back-img-size {
	height: calc(100vh - 151px);
}
.resda-back-img-size-2 {
	/* height: calc(100vh - 151px); */
	width: 40%;
	display: flex;
	align-items: flex-end;
}
.resda-left-cont {
	padding: 10px 30px;
	width: 55%;
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: calc(100vh - 185px);
	margin-top: 20px;
	overflow: auto;
}
.resda-left-cont::-webkit-scrollbar-track {
	background: transparent;
	border-radius: 15px;
}
.resda-left-cont::-webkit-scrollbar-thumb {
	box-shadow: none;
}

.resda-fs-32 {
	font-size: 32px;
}

.resda-fs-20 {
	font-size: 20px;
}

.resda-qual-experience {
	margin-top: 20px;
	box-shadow: 0px 1px 2px 0px #1018280d;
	background: linear-gradient(
		90deg,
		rgba(201, 225, 251, 0.43) 0%,
		rgba(224, 234, 255, 0.43) 100%
	);
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-family: "lato", sans-serif;
	padding: 6px 10px;
	border-radius: 4px;
}

.resda-qual-skill {
	box-shadow: 0px 1px 2px 0px #1018280d;
	background: linear-gradient(
		90deg,
		rgba(255, 221, 128, 0.8) -19.68%,
		rgba(240, 245, 255, 0.8) 100%
	);
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 16px;
	font-family: "lato", sans-serif;
	padding: 6px 10px;
	border-radius: 4px;
}
.resda-greentxt {
	font-style: italic;
	font-weight: 700;
	color: #009045;
}
.resda-blue-txt {
	padding-left: 10px;
	font-style: italic;
	font-weight: 700;
	color: #20639b;
}
.resda-scroll-2 {
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: calc(100vh - 274px);
	overflow: auto;
}
.resda-scroll {
	min-height: 150px;
	height: calc(100vh - 463px);
	/* overflow: auto; */
}
.resda-scroll .wrapper-scroll {
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
	min-height: auto;
	max-height: calc(100vh - 524px);
	overflow: auto;
}
.resda-scroll article {
	position: relative;
	box-shadow: 0px 4px 8px 0px #0090451a;
	background-color: #ffffff;
	border: 2px solid #ffffff;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 600;
	color: #20639b;
	height: 150px;
	width: 135px;
}
.resda-red-border {
	border: 2px solid #ad1927 !important;
}
.resda-card-svg {
	position: absolute;
	right: 10px;
	top: 10px;
}
.resda-red-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 32px;
	font-weight: 600;
	color: #ad1927;
}
.resda-black-txt {
	font-size: 20px;
	font-weight: 400;
}
.resda-card-exp {
	font-family: Montserrat;
	font-weight: 600;
	font-style: Italic;
	font-size: 14px;
	color: #333333;
}
.resda-top {
	border-radius: 12px 12px 0px 0px;
	border: 1px solid #e0e0e0;
	background-color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-block: 15px;
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 600;
	letter-spacing: 0.1em;
	color: #213a5f;
}
.resda-bottom {
	border-radius: 0px 0px 12px 12px;
	background-color: #cae2fc;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-block: 10px;
	font-family: "Inter", sans-serif;
	font-size: 24px;
	font-weight: 900;
	letter-spacing: 0.1em;
	color: #1a4164;
}
.resda-card-dp {
	height: 65px;
	width: 65px;
	border-radius: 35px;
}
.max-wid-85 {
	max-width: 85%;
}
@media only screen and (max-width: 1028px) {
	.resda-main-container {
		background-color: #e9ecef;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		padding: 0px;
		overflow: auto;
		/* position: fixed; */
		top: unset;
		display: block;
	}
	.resda-down-cont {
		height: 92%;
		border-radius: 0px;
		background-color: #e9ecef;
		border: none;
		box-shadow: none;
	}
	.resda-left-cont {
		padding: 15px;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		height: 100%;
		margin-top: unset;
		overflow: auto;
		position: relative;
	}
	.resda-main-container footer {
		background-color: #f9fafb;
		height: 8%;
		padding-inline: 15px;
		display: flex;
		align-items: center;
	}
	.resda-back-img-size {
		height: unset;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 40%;
	}
	.resda-fs-32 {
		font-size: 18px;
		min-width: 211px;
		width: 60%;
	}
	.resda-fs-20 {
		font-size: 14px;
		width: 65%;
	}
	.resda-qual-skill {
		font-size: 14px;
	}
	.resda-card-dp {
		height: 50px;
		width: 50px;
	}
	.resda-scroll article {
		height: 135px;
		width: calc((100% - 40px) / 3);
		gap: 4px;
	}
	.resda-scroll {
		min-height: unset;
		height: unset;
		overflow: unset;
	}
	.resda-card-svg {
		position: absolute;
		right: 5px;
		top: 5px;
	}
	.resda-red-txt {
		font-size: 18px;
	}
	.resda-black-txt {
		font-size: 13px;
		font-weight: 500;
	}
	.resda-top {
		background-color: #f4f6f7;
		font-size: 14px;
		position: relative;
		z-index: 2;
	}
	.resda-bottom {
		font-size: 18px;
		position: relative;
		z-index: 2;
	}
	.resda-back-img-size-2 {
		height: unset;
		display: unset;
		position: absolute;
		bottom: 8%;
		width: 100%;
		z-index: 1;
	}
	.resda-scroll .wrapper-scroll {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		min-height: auto;
		max-height: unset;
		overflow: unset;
	}
}
@media (min-width: 500px) and (max-width: 1025px) {
	.resda-back-img-size {
		height: 130px;
		width: unset;
	}
	.resda-scroll article {
		height: 120px;
		width: calc((100% - 40px) / 3);
	}
	.resda-back-img-size-2 {
		height: unset;
		display: unset;
		position: absolute;
		bottom: 8%;
		right: 0;
		width: 70%;
		z-index: 1;
	}
}
</style>
